module.exports = __webpack_public_path__ + "img/puzzle9.jpg";